module.exports = __webpack_public_path__ + "img/edit_delete_task.842d92a8.png";